import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5c1b73b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "error" }, " Network Error ", -1))
const _hoisted_3 = { class: "message" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Please check your internet connection ", -1))
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" or ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" later ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _hoisted_4,
      _createElementVNode("div", null, [
        _hoisted_5,
        _createElementVNode("a", {
          href: "javascript:void(0);",
          class: "message-btn",
          onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.refresh && _ctx.refresh(...args)), ["prevent"]))
        }, " try again "),
        _hoisted_6
      ])
    ])
  ]))
}